<template>
	<div>
		<div class="d-flex">
			<CCol>
				<div>
					<span
						class="typo-body-2"
						:class="[{'--inactive': !isDisplaying}]"
					>
						{{ navigationMenuItem.name }}
					</span>
					<span v-if="isDisplaying">
						<CBadge
							class="badge-status ml-2"
							color="primary"
						>
							Displaying
						</CBadge>
					</span>
				</div>
				<div
					class="typo-caption date-time mt-1"
					:class="[{ '--inactive': !isDisplaying }]"
				>
					<span>Date time: </span>
					<span>{{ navigationMenuItem.previewStartAt }}</span>
					<span> - </span>
					<span>{{ navigationMenuItem.previewEndAt }}</span>
				</div>
			</CCol>
			<div class="align-self-start typo-body-2">
				<div class="d-flex justify-content-end">
					<CBadge
						class="badge-status"
						:color="STATUS_OBJECT[!!navigationMenuItem.isActive].value"
					>
						{{ STATUS_OBJECT[!!navigationMenuItem.isActive].label }}
					</CBadge>

					<CBadge
						class="badge-status ml-2"
						:color="navigationMenuItem.previewPeriod.color"
					>
						{{ navigationMenuItem.previewPeriod.label }}
					</CBadge>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import {
	STATUS_OBJECT,
} from '../enums/status';

export default {
	name: 'CategoryNavigationMenuItem',

	props: {
		navigationMenuItem: {
			type: Object,
			default: () => {},
		},
		isDisplaying: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			STATUS_OBJECT,
		};
	},
};
</script>

<style lang="scss" scoped>
.date-time {
	font-weight: $font-weight-bold;
	color: $color-gray-70;
}

.--inactive {
	color: #adadad;
}
</style>